import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { IFilterNumber } from '@shared/models/graphql';

import { Store } from '@ngrx/store';
import { AppState } from '@state/app.state';
import {
  setUnsavedStatusFiltersAction,
  setUnsavedPriceFiltersAction,
  setUnsavedSubtypeFiltersAction,
  setUnsavedBedroomsFiltersAction,
  setUnsavedBathroomsFiltersAction,
  setUnsavedSquareFootFiltersAction,
  setUnsavedLotSizeFiltersAction,
  setUnsavedYearBuiltFiltersAction,
  setUnsavedZipFiltersAction,
} from '@state/filters/filters.actions';
import { selectFiltersCurrent } from '@state/filters/filters.selectors';

import { FilterV2StatusComponent } from '../filter-v2-status/filter-v2-status.component';
import { FilterV2PriceComponent } from '../filter-v2-price/filter-v2-price.component';
import { FilterV2BedsComponent } from '../filter-v2-beds/filter-v2-beds.component';
import { FilterV2BathsComponent } from '../filter-v2-baths/filter-v2-baths.component';
import { FilterV2SqftComponent } from '../filter-v2-sqft/filter-v2-sqft.component';
import { FilterV2LotSizeComponent } from '../filter-v2-lot-size/filter-v2-lot-size.component';
import { FilterV2YearBuiltComponent } from '../filter-v2-year-built/filter-v2-year-built.component';
import { FilterV2SubtypeComponent } from '../filter-v2-subtype/filter-v2-subtype.component';
import { FilterV2ZipComponent } from '../filter-v2-zip/filter-v2-zip.component';

@UntilDestroy()
@Component({
  selector: 'app-filter-v2-more',
  templateUrl: './filter-v2-more.component.html',
  styleUrls: [
    './filter-v2-more.component.scss',
    '../filters-v2.component.scss',
  ],
})
export class FilterV2MoreComponent implements OnInit {
  @Output() applyFilters = new EventEmitter();

  @ViewChild(FilterV2StatusComponent) statusFilter!: FilterV2StatusComponent;
  @ViewChild(FilterV2PriceComponent) priceFilter!: FilterV2PriceComponent;
  @ViewChild(FilterV2SubtypeComponent) subtypeFilter!: FilterV2SubtypeComponent;
  @ViewChild(FilterV2BedsComponent) bedsFilter!: FilterV2BedsComponent;
  @ViewChild(FilterV2BathsComponent) bathsFilter!: FilterV2BathsComponent;
  @ViewChild(FilterV2SqftComponent) squareFootFilter!: FilterV2SqftComponent;
  @ViewChild(FilterV2LotSizeComponent) lotSizeFilter!: FilterV2LotSizeComponent;
  @ViewChild(FilterV2YearBuiltComponent)
  yearBuiltFilter!: FilterV2YearBuiltComponent;
  @ViewChild(FilterV2ZipComponent) zipFilter!: FilterV2ZipComponent;

  protected isOpen = false;
  protected isActive = false;

  constructor(private store: Store<AppState>) {}

  ngOnInit(): void {
    this.store
      .select(selectFiltersCurrent)
      .pipe(untilDestroyed(this))
      .subscribe((filters) => {
        if (filters?.status?.in && filters.status.in.length > 0) {
          this.isActive = true;
        } else if (this.verifyIfActive(filters?.price)) {
          this.isActive = true;
        } else if (filters?.subType?.in && filters.subType.in.length > 0) {
          this.isActive = true;
        } else if (this.verifyIfActive(filters?.bedrooms)) {
          this.isActive = true;
        } else if (this.verifyIfActive(filters?.bathrooms)) {
          this.isActive = true;
        } else if (this.verifyIfActive(filters?.squareFoot)) {
          this.isActive = true;
        } else if (this.verifyIfActive(filters?.lotSize)) {
          this.isActive = true;
        } else if (this.verifyIfActive(filters?.yearBuilt)) {
          this.isActive = true;
        } else {
          this.isActive = false;
        }
      });
  }

  verifyIfActive(filter?: IFilterNumber): boolean {
    if (filter) {
      if (filter.greaterThanOrEqual || filter.lessThanOrEqual) {
        return true;
      }
    }
    return false;
  }

  toggleOpen() {
    if (this.isOpen) this.handleCloseModal();
    else this.isOpen = true;
  }

  handleCloseModal() {
    this.isOpen = false;
    this.handleReset(false);
  }

  handleApply() {
    this.applyFilters.emit();
    this.isOpen = false;
  }

  handleReset(apply = true) {
    this.store.dispatch(setUnsavedStatusFiltersAction({}));
    this.store.dispatch(setUnsavedPriceFiltersAction({}));
    this.store.dispatch(setUnsavedSubtypeFiltersAction({}));
    this.store.dispatch(setUnsavedBedroomsFiltersAction({}));
    this.store.dispatch(setUnsavedBathroomsFiltersAction({}));
    this.store.dispatch(setUnsavedSquareFootFiltersAction({}));
    this.store.dispatch(setUnsavedLotSizeFiltersAction({}));
    this.store.dispatch(setUnsavedYearBuiltFiltersAction({}));
    this.store.dispatch(setUnsavedZipFiltersAction({}));

    this.isOpen = false;

    if (apply) {
      this.applyFilters.emit();
    } else {
      this.statusFilter.loadInitialValue();
      this.priceFilter.loadInitialValue();
      this.subtypeFilter.loadInitialValue();
      this.bedsFilter.loadInitialValue();
      this.bathsFilter.loadInitialValue();
      this.squareFootFilter.loadInitialValue();
      this.lotSizeFilter.loadInitialValue();
      this.yearBuiltFilter.loadInitialValue();
      this.zipFilter.loadInitialValue();
    }
  }
}
